/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Time: { input: string; output: string; }
};

export type Basics = {
  __typename?: 'Basics';
  dateOfBirth?: Maybe<Scalars['Time']['output']>;
  gender?: Maybe<Gender>;
  id: Scalars['ID']['output'];
  stateId?: Maybe<Scalars['Int']['output']>;
};

export type BenefitAmount = {
  __typename?: 'BenefitAmount';
  benefitAmount: Scalars['Int']['output'];
  expectIncomeIncrease?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  maximumBenefit: Scalars['Int']['output'];
  minimumBenefit: Scalars['Int']['output'];
};

export type BenefitPeriod = {
  __typename?: 'BenefitPeriod';
  benefitPeriod: BenefitPeriodLength;
  id: Scalars['ID']['output'];
};

export enum BenefitPeriodLength {
  FiveYears = 'FIVE_YEARS',
  TenYears = 'TEN_YEARS',
  ToAge_65 = 'TO_AGE_65',
  ToAge_67 = 'TO_AGE_67',
  TwoYears = 'TWO_YEARS'
}

export type BloodPressure = {
  __typename?: 'BloodPressure';
  controlledWithMedication?: Maybe<Scalars['Boolean']['output']>;
  controlledWithMedicationSince?: Maybe<Scalars['Time']['output']>;
  diastolicPressure?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastTreatedAt?: Maybe<Scalars['Time']['output']>;
  systolicPressure?: Maybe<Scalars['Int']['output']>;
};

export type Depression = {
  __typename?: 'Depression';
  currentlyTreated?: Maybe<Scalars['Boolean']['output']>;
  diagnosedAt?: Maybe<Scalars['Time']['output']>;
  everTreated?: Maybe<Scalars['Boolean']['output']>;
  hospitalized?: Maybe<Scalars['Boolean']['output']>;
  hospitalizedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  numberOfMedications?: Maybe<Scalars['Int']['output']>;
  psychotherapy?: Maybe<Scalars['Boolean']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  treatmentEndDate?: Maybe<Scalars['Time']['output']>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type HealthBasics = {
  __typename?: 'HealthBasics';
  alzheimerDisease?: Maybe<Scalars['Boolean']['output']>;
  asthma?: Maybe<Scalars['Boolean']['output']>;
  backProblems?: Maybe<Scalars['Boolean']['output']>;
  basalCellSkinCancer?: Maybe<Scalars['Boolean']['output']>;
  cancer?: Maybe<Scalars['Boolean']['output']>;
  carpalTunnel?: Maybe<Scalars['Boolean']['output']>;
  copd?: Maybe<Scalars['Boolean']['output']>;
  depression?: Maybe<Scalars['Boolean']['output']>;
  diabetes?: Maybe<Scalars['Boolean']['output']>;
  dwiConviction?: Maybe<Scalars['Boolean']['output']>;
  emphysema?: Maybe<Scalars['Boolean']['output']>;
  epilepsy?: Maybe<Scalars['Boolean']['output']>;
  glaucoma?: Maybe<Scalars['Boolean']['output']>;
  headachesOrMigraines?: Maybe<Scalars['Boolean']['output']>;
  heartDisease?: Maybe<Scalars['Boolean']['output']>;
  heightInInches?: Maybe<Scalars['Int']['output']>;
  highBloodPressure?: Maybe<Scalars['Boolean']['output']>;
  highCholesterol?: Maybe<Scalars['Boolean']['output']>;
  historyOfTobaccoUse?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  kidneyOrLiverDisease?: Maybe<Scalars['Boolean']['output']>;
  kneeInjuryOrSurgery?: Maybe<Scalars['Boolean']['output']>;
  mentalIllness?: Maybe<Scalars['Boolean']['output']>;
  multipleSclerosis?: Maybe<Scalars['Boolean']['output']>;
  otherHealthIssues?: Maybe<Scalars['String']['output']>;
  otherSeriousMedicalConditions?: Maybe<Scalars['Boolean']['output']>;
  planningToBeOrPregnant?: Maybe<Scalars['Boolean']['output']>;
  rheumatoidArthritis?: Maybe<Scalars['Boolean']['output']>;
  sleepApnea?: Maybe<Scalars['Boolean']['output']>;
  stroke?: Maybe<Scalars['Boolean']['output']>;
  suspendedConviction?: Maybe<Scalars['Boolean']['output']>;
  ulcerativeColitisOrIleitis?: Maybe<Scalars['Boolean']['output']>;
  usedInPastYear?: Maybe<Scalars['Boolean']['output']>;
  vascularDisease?: Maybe<Scalars['Boolean']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type Household = {
  __typename?: 'Household';
  annualIncome: Scalars['Int']['output'];
  buyingOrOwningHome: Scalars['Boolean']['output'];
  childrenOrPlanTo: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  spousalQuotesRequested?: Maybe<Scalars['Boolean']['output']>;
  spouseAnnualIncome: Scalars['Int']['output'];
  spouseOrPartner: Scalars['Boolean']['output'];
};

export type Job = {
  __typename?: 'Job';
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  updateBasics?: Maybe<Basics>;
  updateBenefitAmount?: Maybe<BenefitAmount>;
  updateBenefitPeriod?: Maybe<BenefitPeriod>;
  updateBloodPressure?: Maybe<UpdateBloodPressurePayload>;
  updateDepression?: Maybe<UpdateDepressionPayload>;
  updateHealthBasics?: Maybe<UpdateHealthBasicsPayload>;
  updateHousehold?: Maybe<Household>;
  updateOccupation?: Maybe<Occupation>;
  updatePolicyFeatures?: Maybe<PolicyFeatures>;
  updateSleepApnea?: Maybe<UpdateSleepApneaPayload>;
  updateWaitingPeriod?: Maybe<WaitingPeriod>;
};


export type MutationUpdateBasicsArgs = {
  input: UpdateBasicsInput;
};


export type MutationUpdateBenefitAmountArgs = {
  input: UpdateBenefitAmountInput;
};


export type MutationUpdateBenefitPeriodArgs = {
  input: UpdateBenefitPeriodInput;
};


export type MutationUpdateBloodPressureArgs = {
  input: UpdateBloodPressureInput;
};


export type MutationUpdateDepressionArgs = {
  input: UpdateDepressionInput;
};


export type MutationUpdateHealthBasicsArgs = {
  input: UpdateHealthBasicsInput;
};


export type MutationUpdateHouseholdArgs = {
  input: UpdateHouseholdInput;
};


export type MutationUpdateOccupationArgs = {
  input: UpdateOccupationInput;
};


export type MutationUpdatePolicyFeaturesArgs = {
  input: UpdatePolicyFeaturesInput;
};


export type MutationUpdateSleepApneaArgs = {
  input: UpdateSleepApneaInput;
};


export type MutationUpdateWaitingPeriodArgs = {
  input: UpdateWaitingPeriodInput;
};

export type Occupation = {
  __typename?: 'Occupation';
  annualIncomeBeforeCompany?: Maybe<Scalars['Int']['output']>;
  atLeast30HoursAWeek?: Maybe<Scalars['Boolean']['output']>;
  becameOwnerAt?: Maybe<Scalars['Time']['output']>;
  companyFoundedAt?: Maybe<Scalars['Time']['output']>;
  corporateStructure?: Maybe<Scalars['String']['output']>;
  disabilityInsuranceSource?: Maybe<Scalars['String']['output']>;
  disabilityInsuranceStatus?: Maybe<Scalars['Boolean']['output']>;
  educationLevel?: Maybe<Scalars['String']['output']>;
  employerPaysPremium?: Maybe<Scalars['Boolean']['output']>;
  existingCoverage?: Maybe<Scalars['Int']['output']>;
  governmentEmployee?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  individualIncome?: Maybe<Scalars['Int']['output']>;
  intendToReplace?: Maybe<Scalars['Boolean']['output']>;
  job?: Maybe<Job>;
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  numberOfPartners?: Maybe<Scalars['Int']['output']>;
  ownershipStake?: Maybe<Scalars['Int']['output']>;
  selfEmployed?: Maybe<Scalars['Boolean']['output']>;
  workFromHomePercentage?: Maybe<Scalars['Int']['output']>;
  yearsOfExperience?: Maybe<Scalars['Int']['output']>;
};

export type PolicyFeatures = {
  __typename?: 'PolicyFeatures';
  id: Scalars['ID']['output'];
  noncancellable: Scalars['Boolean']['output'];
  ownOccupationPolicy: Scalars['Boolean']['output'];
  residualDisabilityPolicy: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  bloodPressure: BloodPressure;
  currentUser: User;
  depression: Depression;
  healthBasics: HealthBasics;
  searchJobs: Array<Job>;
  sleepApnea: SleepApnea;
  surveyBasics: Basics;
  surveyBenefitAmount: BenefitAmount;
  surveyBenefitPeriod: BenefitPeriod;
  surveyHousehold: Household;
  surveyOccupation: Occupation;
  surveyPolicyFeatures: PolicyFeatures;
  surveyWaitingPeriod: WaitingPeriod;
};


export type QuerySearchJobsArgs = {
  search: Scalars['String']['input'];
};

export type SleepApnea = {
  __typename?: 'SleepApnea';
  apneaHypopneaIndex?: Maybe<Scalars['Int']['output']>;
  apneaIndex?: Maybe<Scalars['Int']['output']>;
  diagnosedAt?: Maybe<Scalars['Time']['output']>;
  everTreated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  oxygenSaturation?: Maybe<Scalars['Int']['output']>;
  respiratoryDisturbanceIndex?: Maybe<Scalars['Int']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  sleepStudyConducted?: Maybe<Scalars['Boolean']['output']>;
  sleepStudyConductedAt?: Maybe<Scalars['Time']['output']>;
  treatedAt?: Maybe<Scalars['Time']['output']>;
  usesCPAPMachine?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateBasicsInput = {
  dateOfBirth: Scalars['Time']['input'];
  gender: Gender;
  stateId: Scalars['Int']['input'];
};

export type UpdateBenefitAmountInput = {
  benefitAmount: Scalars['Int']['input'];
  expectIncomeIncrease: Scalars['Boolean']['input'];
};

export type UpdateBenefitPeriodInput = {
  benefitPeriod: BenefitPeriodLength;
};

export type UpdateBloodPressureInput = {
  controlledWithMedication?: InputMaybe<Scalars['Boolean']['input']>;
  controlledWithMedicationSince?: InputMaybe<Scalars['Time']['input']>;
  diastolicPressure?: InputMaybe<Scalars['Int']['input']>;
  lastTreatedAt?: InputMaybe<Scalars['Time']['input']>;
  systolicPressure?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBloodPressurePayload = {
  __typename?: 'UpdateBloodPressurePayload';
  form: BloodPressure;
  nextStepPath?: Maybe<Scalars['String']['output']>;
};

export type UpdateDepressionInput = {
  currentlyTreated?: InputMaybe<Scalars['Boolean']['input']>;
  diagnosedAt?: InputMaybe<Scalars['Time']['input']>;
  everTreated?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalized?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalizedAt?: InputMaybe<Scalars['Time']['input']>;
  numberOfMedications?: InputMaybe<Scalars['Int']['input']>;
  psychotherapy?: InputMaybe<Scalars['Boolean']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  treatmentEndDate?: InputMaybe<Scalars['Time']['input']>;
};

export type UpdateDepressionPayload = {
  __typename?: 'UpdateDepressionPayload';
  form: Depression;
  nextStepPath?: Maybe<Scalars['String']['output']>;
};

export type UpdateHealthBasicsInput = {
  alzheimerDisease?: InputMaybe<Scalars['Boolean']['input']>;
  asthma?: InputMaybe<Scalars['Boolean']['input']>;
  backProblems?: InputMaybe<Scalars['Boolean']['input']>;
  basalCellSkinCancer?: InputMaybe<Scalars['Boolean']['input']>;
  cancer?: InputMaybe<Scalars['Boolean']['input']>;
  carpalTunnel?: InputMaybe<Scalars['Boolean']['input']>;
  copd?: InputMaybe<Scalars['Boolean']['input']>;
  depression?: InputMaybe<Scalars['Boolean']['input']>;
  diabetes?: InputMaybe<Scalars['Boolean']['input']>;
  dwiConviction: Scalars['Boolean']['input'];
  emphysema?: InputMaybe<Scalars['Boolean']['input']>;
  epilepsy?: InputMaybe<Scalars['Boolean']['input']>;
  glaucoma?: InputMaybe<Scalars['Boolean']['input']>;
  headachesOrMigraines?: InputMaybe<Scalars['Boolean']['input']>;
  heartDisease?: InputMaybe<Scalars['Boolean']['input']>;
  heightInInches: Scalars['Int']['input'];
  highBloodPressure?: InputMaybe<Scalars['Boolean']['input']>;
  highCholesterol?: InputMaybe<Scalars['Boolean']['input']>;
  historyOfTobaccoUse: Scalars['Boolean']['input'];
  kidneyOrLiverDisease?: InputMaybe<Scalars['Boolean']['input']>;
  kneeInjuryOrSurgery?: InputMaybe<Scalars['Boolean']['input']>;
  mentalIllness?: InputMaybe<Scalars['Boolean']['input']>;
  multipleSclerosis?: InputMaybe<Scalars['Boolean']['input']>;
  otherHealthIssues?: InputMaybe<Scalars['String']['input']>;
  otherSeriousMedicalConditions?: InputMaybe<Scalars['Boolean']['input']>;
  planningToBeOrPregnant?: InputMaybe<Scalars['Boolean']['input']>;
  rheumatoidArthritis?: InputMaybe<Scalars['Boolean']['input']>;
  sleepApnea?: InputMaybe<Scalars['Boolean']['input']>;
  stroke?: InputMaybe<Scalars['Boolean']['input']>;
  suspendedConviction: Scalars['Boolean']['input'];
  ulcerativeColitisOrIleitis?: InputMaybe<Scalars['Boolean']['input']>;
  usedInPastYear?: InputMaybe<Scalars['Boolean']['input']>;
  vascularDisease?: InputMaybe<Scalars['Boolean']['input']>;
  weight: Scalars['Int']['input'];
};

export type UpdateHealthBasicsPayload = {
  __typename?: 'UpdateHealthBasicsPayload';
  form: HealthBasics;
  nextStepPath?: Maybe<Scalars['String']['output']>;
};

export type UpdateHouseholdInput = {
  annualIncome: Scalars['Int']['input'];
  buyingOrOwningHome: Scalars['Boolean']['input'];
  childrenOrPlanTo: Scalars['Boolean']['input'];
  spousalQuotesRequested?: InputMaybe<Scalars['Boolean']['input']>;
  spouseAnnualIncome: Scalars['Int']['input'];
  spouseOrPartner: Scalars['Boolean']['input'];
};

export type UpdateOccupationInput = {
  annualIncomeBeforeCompany?: InputMaybe<Scalars['Int']['input']>;
  atLeast30HoursAWeek?: InputMaybe<Scalars['Boolean']['input']>;
  becameOwnerAt?: InputMaybe<Scalars['Time']['input']>;
  companyFoundedAt?: InputMaybe<Scalars['Time']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  disabilityInsuranceSource?: InputMaybe<Scalars['String']['input']>;
  disabilityInsuranceStatus?: InputMaybe<Scalars['Boolean']['input']>;
  educationLevel?: InputMaybe<Scalars['String']['input']>;
  employerPaysPremium?: InputMaybe<Scalars['Boolean']['input']>;
  existingCoverage?: InputMaybe<Scalars['Int']['input']>;
  governmentEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  individualIncome?: InputMaybe<Scalars['Int']['input']>;
  intendToReplace?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitleId?: InputMaybe<Scalars['Int']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  numberOfPartners?: InputMaybe<Scalars['Int']['input']>;
  ownershipStake?: InputMaybe<Scalars['Int']['input']>;
  selfEmployed?: InputMaybe<Scalars['Boolean']['input']>;
  workFromHomePercentage?: InputMaybe<Scalars['Int']['input']>;
  yearsOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePolicyFeaturesInput = {
  noncancellable: Scalars['Boolean']['input'];
  ownOccupationPolicy: Scalars['Boolean']['input'];
  residualDisabilityPolicy: Scalars['Boolean']['input'];
};

export type UpdateSleepApneaInput = {
  apneaHypopneaIndex?: InputMaybe<Scalars['Int']['input']>;
  apneaIndex?: InputMaybe<Scalars['Int']['input']>;
  diagnosedAt?: InputMaybe<Scalars['Time']['input']>;
  everTreated?: InputMaybe<Scalars['Boolean']['input']>;
  oxygenSaturation?: InputMaybe<Scalars['Int']['input']>;
  respiratoryDisturbanceIndex?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  sleepStudyConducted?: InputMaybe<Scalars['Boolean']['input']>;
  sleepStudyConductedAt?: InputMaybe<Scalars['Time']['input']>;
  treatedAt?: InputMaybe<Scalars['Time']['input']>;
  usesCPAPMachine?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSleepApneaPayload = {
  __typename?: 'UpdateSleepApneaPayload';
  form: SleepApnea;
  nextStepPath?: Maybe<Scalars['String']['output']>;
};

export type UpdateWaitingPeriodInput = {
  waitingPeriod: Scalars['Int']['input'];
};

export type User = {
  __typename?: 'User';
  dateOfBirth?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id: Scalars['ID']['output'];
};

export type WaitingPeriod = {
  __typename?: 'WaitingPeriod';
  id: Scalars['ID']['output'];
  waitingPeriod: Scalars['Int']['output'];
};
